import styles from "@/components/pages/key-bpm-finder/components/styles/key-bpm-finder-player.module.scss";
import React, { MutableRefObject } from "react";
import PlayerProgress from "@/components/common/music-player/player-progress";
import PlayerButton from "@/components/common/player-button";
import useAudioPlayer from "@/hooks/music-players/use-audio-player";

type PlayerProps = {
  trackUrl: string;
  handlePlayTrack: (
    playerRef: MutableRefObject<HTMLAudioElement>,
  ) => Promise<void>;
  isPlayerActive: (playerRef: MutableRefObject<HTMLAudioElement>) => boolean;
};

const KeyBpmFinderPlayer = ({
  trackUrl,
  handlePlayTrack,
  isPlayerActive,
}: PlayerProps) => {
  const {
    musicPlayer,
    progressRef,
    changeRange,
    onDurationChanged,
    onTimeUpdate,
  } = useAudioPlayer();

  return (
    <div className={styles.wrapper}>
      <audio
        ref={musicPlayer}
        onDurationChange={onDurationChanged}
        onTimeUpdate={onTimeUpdate}
        src={trackUrl}
      />
      <div className={styles.player}>
        <PlayerButton
          handleClick={() => handlePlayTrack(musicPlayer)}
          isPlaying={isPlayerActive(musicPlayer)}
          size={40}
        />
        <PlayerProgress
          musicPlayer={musicPlayer}
          progressRef={progressRef}
          onChange={changeRange}
        />
      </div>
    </div>
  );
};

export default KeyBpmFinderPlayer;
